export default __webpack_public_path__ + "static/media/img005.e9b58503.png";